export default __webpack_public_path__ + "static/media/more_vertical.314ecece.svg";